interface MiniSparklineProps {
    values: number[];
    height?: number;
    className?: string;
}

/** Sparkline SVG leve e monocromática (usa currentColor). */
export function MiniSparkline({ values, height = 32, className }: MiniSparklineProps) {
    const data = (values || []).filter((v) => Number.isFinite(v));
    if (data.length < 2) {
        return <div style={{ height }} className={className} />;
    }

    const width = 240;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const stepX = width / (data.length - 1);
    const pad = 3;

    const points = data.map((v, i) => {
        const x = i * stepX;
        const y = height - pad - ((v - min) / range) * (height - pad * 2);
        return [x, y] as const;
    });

    const line = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`).join(' ');

    return (
        <svg
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            className={className}
            style={{ width: '100%', height }}
        >
            <path
                d={line}
                fill="none"
                stroke="currentColor"
                strokeWidth={1.25}
                strokeLinejoin="round"
                strokeLinecap="round"
                vectorEffect="non-scaling-stroke"
            />
        </svg>
    );
}
